<script setup>
/* Hängt einmal in App.vue. Zeigt die Meldung aus useSnackbar.js: unten mittig, Farben aus dem
   AFH-Farbsystem (Fläche des Panels, Rand und Text je nach Art in Grün/Amber/Rot-Tönen der
   bestehenden Variablen). Warnungen bleiben länger stehen. */
import { computed } from 'vue';
import { useSnackbar } from '../composables/useSnackbar.js';

const { state, hide } = useSnackbar();
const timeout = computed(() => (state.value.kind === 'success' ? 4000 : 9000));
const open = computed({
  get: () => state.value.open,
  set: (v) => { if (!v) hide(); },
});
</script>

<template>
  <v-snackbar
    v-model="open"
    :timeout="timeout"
    location="bottom"
    :content-class="`app-snack app-snack--${state.kind}`"
    role="status"
  >
    {{ state.text }}
    <template #actions>
      <button type="button" class="app-snack-close" :aria-label="$t('common.close')" @click="hide">✕</button>
    </template>
  </v-snackbar>
</template>

<style>
/* Ungebunden (nicht scoped): Der Inhalt wird von Vuetify außerhalb dieser Komponente eingehängt. */
.app-snack {
  background: var(--panel) !important;
  color: var(--text) !important;
  border: 1px solid var(--border);
  border-left-width: 3px;
  font-family: var(--sans);
  font-size: var(--fs-sm);
}
.app-snack--success { border-left-color: var(--green); }
.app-snack--warning { border-left-color: var(--amber); }
.app-snack--error { border-left-color: var(--red); }
.app-snack-close {
  background: none;
  border: 0;
  color: var(--muted);
  cursor: pointer;
  padding: 4px 8px;
  font-size: var(--fs-sm);
}
.app-snack-close:hover { color: var(--text); }
</style>
